import React, { useEffect, useMemo } from "react";
import { Modal } from "react-bootstrap";
import { ModalProgressBar } from "../../../../../../_metronic/partials/control";
// import * as actions from "../../../_redux/loans/loansActions";
import { useLoansUIContext, LoansUIContextModel } from '../LoansUIContext';
import axios from 'axios';
import Swal from 'sweetalert2';
import { LoansLoadingDialog } from '../loans-loading-dialog/LoansLoadingDialog';

export interface LoanDeleteDialogProps {
  id?: number | null;
  fullDelete?: number | null;
  show: boolean
  onHide: () => void
}
export const LoanDeleteDialog: React.FC<LoanDeleteDialogProps> = ({ id, fullDelete, show, onHide }) => {
  // Loans UI Context
  const loansUIContext = (useLoansUIContext() as LoansUIContextModel);
  const loansUIProps = useMemo(() => {
    return {
      setIds: loansUIContext.setIds,
      queryParams: loansUIContext.queryParams,
      selectedLoan: loansUIContext.selectedLoan,
      fetchLoan: loansUIContext.fetchLoan,
      loadLoan: loansUIContext.loadLoan,
      loadLoans: loansUIContext.loadLoans,
      setIsLoading: loansUIContext.setIsLoading
    };
  }, [loansUIContext]);
  const status = 0
  // Loans Redux state
  // const { isLoading } = useSelector(
  //   (state) => ({ isLoading: state.loans.actionsLoading }),
  //   shallowEqual
  // );

  // if !id we should close modal
  useEffect(() => {
    if (!id) {
      onHide();
    } else {
      loansUIProps.fetchLoan((id as number));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // looking for loading/dispatch
  // useEffect(() => {}, [ dispatch]);

  const deleteLoan = async() => {
    onHide();
    loansUIProps.setIsLoading(true);
    try {
      if(fullDelete === 1) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/loan/${id}`,
          {
            ...loansUIProps.selectedLoan,
            status: 0,
          }
        )
        loansUIProps.setIsLoading(false);
        Swal.fire({
          title: `Prestamo desactivado correctamente`,
          icon: 'success'
        }).then(()=>{
          loansUIProps.loadLoans()
        })
      } else {
        await axios.delete(
          `${process.env.REACT_APP_API_URL}/loan/${id}`
        )
        loansUIProps.setIsLoading(false);
        Swal.fire({
          title: 'Prestamo eliminado correctamente',
          icon: 'success'
        }).then(()=>{
          loansUIProps.loadLoans()
        })
      }
    } catch (error) {
      console.log('error', error)
      loansUIProps.setIsLoading(false);
      Swal.fire({
        title: 'Error al desactivar prestamo',
        icon: 'error'
      }).then(()=>{
        loansUIProps.loadLoans()
      })
    } 
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      aria-labelledby="example-modal-sizes-title-lg"
    >
      {/*begin::Loading*/}
      {false && <ModalProgressBar />}
      {/*end::Loading*/}
      <Modal.Header closeButton>
        <Modal.Title id="example-modal-sizes-title-lg">
          { loansUIProps.loadLoan ? 'Cargando...' : `
           Eliminar 
          prestamo ${loansUIProps.selectedLoan?.reference}`}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loansUIProps.loadLoan && <LoansLoadingDialog color={"primary"}/>}
        {!loansUIProps.loadLoan && (
          <span>
            { fullDelete === 1 ? status ? "¿Está seguro que desea desactivar este prestamo?" : "¿Está seguro que desea activar este prestamo?" : "¿Está seguro que desea eliminar este prestamo?"}
          </span>
        )}
      </Modal.Body>
      <Modal.Footer>
        {
          !loansUIProps.loadLoan && 
            <div>
              <button
                type="button"
                onClick={onHide}
                className="btn btn-light btn-elevate"
              >
                Cancel
              </button>
              <> </>
              <button
                type="button"
                onClick={deleteLoan}
                className={`btn btn-danger btn-elevate`}
              >
                {"Eliminar"}
              </button>
            </div>
        }
      </Modal.Footer>
    </Modal>
  );
}


